import { Link } from 'react-router-dom';
import { useSEO } from '../../../utils/seo';

export default function OrangevaleAreaPage() {
  useSEO({
    title: 'Pressure Washing Orangevale CA - Professional Cleaning Services | Mr. EcoClean',
    description: 'Expert pressure washing in Orangevale CA. House washing, solar panel cleaning, driveway cleaning. Serving all Orangevale areas. Call (916) 836-6145 for free quote.',
    keywords: 'pressure washing Orangevale, Orangevale pressure washing, house washing Orangevale',
    canonical: '/areas/orangevale',
    ogType: 'website'
  });

  return (
    <div className="min-h-screen bg-white">
      <header className="bg-white shadow-sm">
        <nav className="mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <Link to="/" className="cursor-pointer">
              <h1 className="text-2xl font-bold text-red-600" style={{ fontFamily: '"Pacifico", serif' }}>Mr. EcoClean</h1>
            </Link>
            <div className="hidden md:flex space-x-8">
              <Link to="/" className="text-gray-700 hover:text-red-600 font-medium whitespace-nowrap cursor-pointer">Home</Link>
              <Link to="/services" className="text-gray-700 hover:text-red-600 font-medium whitespace-nowrap cursor-pointer">Services</Link>
              <Link to="/areas-covered" className="text-gray-700 hover:text-red-600 font-medium whitespace-nowrap cursor-pointer">Areas Covered</Link>
              <Link to="/contact" className="text-gray-700 hover:text-red-600 font-medium whitespace-nowrap cursor-pointer">Contact</Link>
            </div>
          </div>
        </nav>
      </header>

      <section className="relative bg-cover bg-center bg-no-repeat py-32" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/511e919ba065cddc9aed85b21a6012c7.jpg')` }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">Pressure Washing Services in Orangevale, CA</h2>
          <p className="text-xl text-white mb-8 max-w-3xl mx-auto">Professional pressure washing for Orangevale homes and businesses. Serving all Orangevale communities.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" className="bg-red-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer">Get Free Quote</Link>
            <a href="tel:916-836-6145" className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer">Call (916) 836-6145</a>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h3 className="text-4xl font-bold text-gray-900 mb-12 text-center">Orangevale Pressure Washing Services</h3>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="w-16 h-16 bg-sky-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-sun-line text-2xl text-sky-600"></i>
              </div>
              <h4 className="text-2xl font-bold text-gray-900 mb-4">Solar Panel Cleaning</h4>
              <p className="text-gray-600 mb-6">Keep your Orangevale solar panels operating at peak efficiency.</p>
              <Link to="/contact" className="text-sky-600 font-semibold hover:text-sky-700 cursor-pointer">Get Quote →</Link>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="w-16 h-16 bg-sky-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-home-4-line text-2xl text-sky-600"></i>
              </div>
              <h4 className="text-2xl font-bold text-gray-900 mb-4">House Washing</h4>
              <p className="text-gray-600 mb-6">Complete exterior cleaning for Orangevale homes.</p>
              <Link to="/contact" className="text-sky-600 font-semibold hover:text-sky-700 cursor-pointer">Get Quote →</Link>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="w-16 h-16 bg-sky-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-road-map-line text-2xl text-sky-600"></i>
              </div>
              <h4 className="text-2xl font-bold text-gray-900 mb-4">Driveway Cleaning</h4>
              <p className="text-gray-600 mb-6">Remove stains and restore your Orangevale driveway.</p>
              <Link to="/contact" className="text-sky-600 font-semibold hover:text-sky-700 cursor-pointer">Get Quote →</Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-red-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-4xl font-bold text-white mb-6">Serving All of Orangevale</h3>
          <p className="text-xl text-red-100 mb-8">Get a free quote for pressure washing services in Orangevale today.</p>
          <a href="tel:916-836-6145" className="bg-white text-red-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer inline-block">Call: (916) 836-6145</a>
        </div>
      </section>

      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-gray-400">&copy; 2024 Mr. EcoClean. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-sky-400 cursor-pointer">Website Builder</a></p>
        </div>
      </footer>
    </div>
  );
}
